export const obtenerPlaca = (placa) => {

    let obj = placa.replaceAll(' ', '')
    let obj2 = obj.replaceAll('-', '')

    return obj2.toUpperCase()


}